import React from 'react';

const ErrorPage = () => {

  return (
    <div style={styles.div}>
      <h1> Data Layer is not ready - potential connection issue with the PPC. Please look at the Data Layer logs for further details.</h1>
      <h3> Please navigate to C:\Program Files (x86)\Data Layer or C:\Program Files\Data Layer and open the latest .log file.</h3>
    </div>
  );
};

const styles = {
  div: {
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  }
};

export default ErrorPage;